module.exports = __webpack_public_path__ + "public/img/green_car.ab98f634.png";